import { render } from "./PanelTipsterEmbudo.vue?vue&type=template&id=3ab16e31&scoped=true"
import script from "./PanelTipsterEmbudo.vue?vue&type=script&lang=js"
export * from "./PanelTipsterEmbudo.vue?vue&type=script&lang=js"

import "./PanelTipsterEmbudo.vue?vue&type=style&index=0&id=3ab16e31&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab16e31"]])

export default __exports__